import axios from 'axios'

export const http = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  timeout: 60000,
  withCredentials: true,
})

export const branchWebHttp = axios.create({
  baseURL: import.meta.env.VITE_BRANCH_WEB_API_URL,
  timeout: 60000,
})
